<div class="row mt-n1">
    <div class="col-md-12">
        <div class="card card-accent-success animated fadeIn">
            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                <div class="card-header-buscador">
                    <i class="fa fa-file-text-o"></i> Tipos de inspección (a cumplimentar) configurados para el periodo
                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                </div>
            </a>
            <div class="card-body-detalle">
                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">
                    <div class="nota-info">
                        <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> En éste cuadrante solamente aparecen las inspecciones con resultado favorable.</label>
                    </div>
    
                    <!-- Lista de inspecciones NO obligatorias, indicando cumplimentadas o no -->
                     <div class="row">
                        <div *ngIf="inspeccionesUIPeriodoNoObligatorias?.size > 0" class="col-5 m-2">
                            <h5 class="pt-2 p-1">No Obligatorias</h5>
                            <div *ngFor="let inspeccionUIPeriodoNoObligatoria of inspeccionesUIPeriodoNoObligatorias | keyvalue" class="row">
                                
                                <div class="card" [ngClass]="{ 'pendientes': (inspeccionUIPeriodoNoObligatoria.value.cumplimentadas < inspeccionUIPeriodoNoObligatoria.value.configuradas),
                                                                'cumplimentadas': (inspeccionUIPeriodoNoObligatoria.value.cumplimentadas >= inspeccionUIPeriodoNoObligatoria.value.configuradas) }">
                                    <div class="card-title">
                                        <div class="row">
                                            <div class="form-group ms-1">
                                                <label class="ps-1 col-form-label">{{ inspeccionUIPeriodoNoObligatoria.value.tipoInspeccion }}</label>
                                                <span>({{ inspeccionUIPeriodoNoObligatoria.value.cumplimentadas }} de {{ inspeccionUIPeriodoNoObligatoria.value.configuradas }})</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row pb-2">
                                        <span class="ms-2 card-text">{{ inspeccionUIPeriodoNoObligatoria.value.nombre }}</span> 
                                    </div>
                                </div>
                                
                            </div>
                        </div>
        
                        <!-- Lista de inspecciones obligatorias, indicando cumplimentadas o no -->
                        <div *ngIf="inspeccionesUIPeriodoObligatorias?.size > 0" class="col-5 m-2">
                            <h5 class="pt-2 p-1">Obligatorias</h5>
                            <div *ngFor="let inspeccionUIPeriodoObligatoria of inspeccionesUIPeriodoObligatorias | keyvalue" class="row">
                                
                                <div class="card" [ngClass]="{ 'pendientes': (inspeccionUIPeriodoObligatoria.value.cumplimentadas < inspeccionUIPeriodoObligatoria.value.configuradas),
                                                                'cumplimentadas': (inspeccionUIPeriodoObligatoria.value.cumplimentadas >= inspeccionUIPeriodoObligatoria.value.configuradas) }">
                                    <div class="card-title">
                                        <div class="row">
                                            <div class="form-group ms-1">
                                                <label class="ps-1 col-form-label">{{ inspeccionUIPeriodoObligatoria.value.tipoInspeccion }}</label>
                                                <span>({{ inspeccionUIPeriodoObligatoria.value.cumplimentadas }} de {{ inspeccionUIPeriodoObligatoria.value.configuradas }})</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row pb-2">
                                        <span class="ms-2 card-text">{{ inspeccionUIPeriodoObligatoria.value.nombre }}</span> 
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
</div>